import React from 'react';

import { Field, Form, FormikProps, withFormik } from 'formik';
import * as yup from 'yup';

import { Alert, Button, FormikInput } from '../';
import _ from '../../locale';
import { PasswordSchema, PasswordWithMinCharactersSchema } from '../../models/form-validation';
import { styled } from '../../theme';

const StyledAlert = styled(Alert)({
    marginBottom: 20,
});

type FormValues = {
    password: string;
    new_password: string;
    new_password_confirmation: string;
};

type Props = {
    changePassword: (password: string, newPassword: string) => void;
    onSuccess: () => void;
};

const mapNameToLabel = (name: string) => _('form_field_' + name);

const InnerForm: React.FC<Props & FormikProps<FormValues>> = (props) => {
    const { isSubmitting, status } = props;
    return (
        <Form>
            {status && status.error && <StyledAlert color="error">{status.error}</StyledAlert>}
            {status && status.success && (
                <StyledAlert color="success">{status.success}</StyledAlert>
            )}

            <Field
                name="password"
                component={FormikInput}
                mapNameToLabel={mapNameToLabel}
                type="password"
                required
                autoFocus
                data-private
            />

            <Field
                name="new_password"
                component={FormikInput}
                mapNameToLabel={mapNameToLabel}
                type="password"
                required
                data-private
            />

            <Field
                name="new_password_confirmation"
                component={FormikInput}
                mapNameToLabel={mapNameToLabel}
                type="password"
                required
                data-private
            />

            <Button color="primary" type="submit" disabled={isSubmitting} style={{ width: '100%' }}>
                {_('change_password_button')}
            </Button>
        </Form>
    );
};

export default withFormik<Props, FormValues>({
    validateOnBlur: false,
    validateOnChange: false,
    // initialize values
    mapPropsToValues: () => ({
        password: '',
        new_password: '',
        new_password_confirmation: '',
    }),

    validationSchema: yup.object().shape({
        password: PasswordSchema,
        new_password: PasswordWithMinCharactersSchema,
        new_password_confirmation: PasswordWithMinCharactersSchema.oneOf(
            [yup.ref('new_password'), null],
            'Passwords have to match'
        ),
    }),
    handleSubmit: (values, form) => {
        const { changePassword, onSuccess } = form.props;

        changePassword(values.password, values.new_password)
            .then((response) => {
                form.setStatus({ success: _('change_password_success_message') });
                form.setSubmitting(false);

                onSuccess();
            })
            .catch((error) => {
                form.setStatus({ error: error.message });
                form.setSubmitting(false);
            });
    },
})(InnerForm);
